import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { HomeComponentContainer } from './styled';
import { CLIENTS, CLIENTS_XS } from '../Assets';
import { CustomizedTypography } from '@components/Customized';
import { MediaQuery } from '../HomePresenter';
import { colorSet } from '@components/Provider';

const Clients: React.FC = () => {
  const { contentBox, container } = useStyles();
  const { md, sm } = useContext(MediaQuery);
  return (
    <HomeComponentContainer
      className={container}
      padding={sm ? '84px 16px 100px' : md ? '80px 0px 100px' : '80px 0px 90px'}
    >
      <Box className={contentBox}>
        <CustomizedTypography
          variant={sm ? 'body1' : md ? 'h4' : 'subtitle1'}
          color="textPrimary"
          fontWeight="500"
        >
          CAPA는 국내외 1만여 고객사와 {sm && <br />}함께하고 있습니다!
        </CustomizedTypography>
        <img
          src={sm ? CLIENTS_XS : CLIENTS}
          width="100%"
          height="auto"
          alt="clients"
        />
      </Box>
    </HomeComponentContainer>
  );
};

export default Clients;

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: colorSet.gray200
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '40px',
    textAlign: 'center',
    '& h6': {
      fontSize: '18px'
    },
    [theme.breakpoints.down('md')]: {
      gap: '48px'
    },
    [theme.breakpoints.down('sm')]: {
      gap: '32px',
      '& img': {
        maxWidth: 344
      }
    }
  }
}));
